
// import { verifyPhone } from './util';
export function verifyPhone(str){
    if(!/^1\d{10}$/.test(str)){
        return false;
    }
    return true;
}

export function verifyEmail(str){
    if(!/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(str)){
        return false;
    }
    return true;
}

export function verifyPassword(str){
    if(!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,12}$/.test(str)){
        return false;
    }
    return true;
}

export function Text2Html(str){
    if (str == null) {
        return "";
    }else if (str.length() == 0) {
        return "";
    }
    str = str.replaceAll("\n", "<br />");
    str = str.replaceAll("\r", "<br />");
    return str;
}

